import * as React from 'react';
import { useEffect } from 'react';
import { Input, inputType } from 'components/input/input';
import { Button, buttonType } from 'components/button/button';
import './login-with-password.scss';
import { IsNumericText, ToEn } from 'core/utils/decimalExtentions';
import { phoneRegex } from 'core/utils/regexs';
import { getViaAuth, postGeneric, responseValidator } from 'apis/api';
import { API } from 'apis';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

interface Props {}

export interface LoginResult {
    accessToken: string;
    expiresIn: number;
    isAuthorized: boolean;
    isTwoFactorEnabled: boolean;
    refreshToken: string;
    roles: string[];
    tokenType: string;
}

export const LoginWithPassword: React.FC<Props> = () => {
    const [password, setPassword] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);
    const [phoneNumber, setPhoneNumber] = React.useState<string>('');

    const navigate = useNavigate();

    const phone = localStorage.getItem('phone') || '';

    useEffect(() => localStorage.clear(), []);

    function Login() {
        setLoading(true);
        postGeneric<LoginResult>(API.general.verifyCode, {
            phoneNumber: phoneNumber,
            password: password,
        })
            .then(async (res) => {
                setLoading(false);
                if (responseValidator(res.status)) {
                    if (res?.value.isTwoFactorEnabled == true) {
                        localStorage.setItem('phone', phoneNumber);
                        navigate('/signin/code');
                    } else {
                        res.value.accessToken && localStorage.setItem('accessToken', res.value.accessToken);
                        res.value.refreshToken && localStorage.setItem('refresh', res.value.refreshToken);
                        localStorage.setItem('date', moment.utc().toString());
                        res.value.expiresIn && localStorage.setItem('expiresIn', res.value.expiresIn.toString());
                        localStorage.setItem('isAuthorized', res.value.isAuthorized.toString());
                        localStorage.setItem('level', res.value.isTwoFactorEnabled.toString());
                        res.value.roles && localStorage.setItem('roles', res.value.roles.join(','));
                        localStorage.setItem('tokenType ', res.value.tokenType);
                        await getViaAuth(API.roles.getMineMenuItems).then((res: any) => {
                            if (responseValidator(res.status)) {
                                res.data && localStorage.setItem('menuItems', JSON.stringify(res?.data));
                            }
                        });
                        navigate('/dashboard/users');
                    }
                }
            })
            .catch((err) => {
                navigate('/signin');
            });
    }

    useEffect(() => {}, []);
    return (
        <div className="login-with-password">
            <div className="title">
                <h3>ورود یا ثبت نام</h3>
            </div>
            <p>برای ورود، اطلاعات زیر را وارد کنید.</p>

            <Input
                placeholder="شماره موبایل"
                value={phone || phoneNumber}
                onChange={(e) => IsNumericText(ToEn(e.target.value)) && setPhoneNumber(ToEn(e.target.value))}
                htmlType={'text'}
                maxLength={11}
                onPressEnter={Login}
            />
            <Input
                placeholder="رمز عبور"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                htmlType={'password'}
                type={inputType.text}
                onPressEnter={Login}
            />

            <Button
                disabled={ToEn(phoneNumber).search(phoneRegex) !== 0 || !password}
                type={buttonType.info}
                text="ورود"
                loading={loading}
                onClick={() => Login()}
            />
        </div>
    );
};
